<template>
  <div>
    <!--选择支付-->
    <div class="payBox" v-show="witchPay === 0">
      <span>恭喜！您已于 </span><span style="color: #418fbf">{{confirmedAt}}</span><span> 通过终审！请在5日内一次缴纳五年会员费用。<br>应缴纳的会员费用为：</span>
      <span class="payNum">{{amountTotal}}</span>
      <span>元</span>
      <p>请选择付款方式</p>
      <div>
        <img class="paywayimg" src="../../assets/img/weipay.png" @click="wechatPay">
        <img class="paywayimg" src="../../assets/img/zhipay.png" @click="zhiPay" style="margin-left: 30px">
      </div>
    </div>
    <!--微信支付-->
    <div class="weBox" v-show="witchPay === 1">
      <p class="weTitle">微信支付</p>
      <img class="weCode" v-if="wechatCodeimg" :src="wechatCodeimg">
      <p class="backPay" @click="backPay">重新选择支付方式</p>
    </div>
    <!--支付宝支付-->
    <div>
      <div v-html="zhiForm">{{zhiForm}}</div>
    </div>
    <!--支付成功-->
    <div class="endBox" v-show="witchPay === 3">
      <span class="payTitle">支付成功，工作人员将在5个工作日内对您的支付进行最终审核</span>
    </div>
    <!--支付成功-->
    <div class="endBox" v-show="witchPay === 4">
      <span class="payTitle" style="color: #e73a2e">支付失败，若已扣款，请联系网站客服人员</span>
    </div>
  </div>
</template>

<script>
import HttpServer from '@/utils' // 接口请求
export default {
  name: 'processPay',
  props: ['amountTotal', 'confirmedAt'],
  data () {
    return {
      wechatCodeimg: '', // 微信支付二维码
      witchPay: 0, // 支付方式 0选择；1微信；2支付宝；3支付成功；4支付失败
      timer: null, // 定时器
      zhiForm: '' // 返回的form代码
    }
  },
  methods: {
    // 选择微信支付，并获得二维码
    wechatPay () {
      // 加载微信支付组件
      this.witchPay = 1
      // 定义请求头
      let config = {
        headers: {
          'Authorization': 'Bearer' + this.$store.state.Token
        }
      }
      // 调用微信支付接口
      HttpServer.get('http://api.gdics.cn/api/wepay', config)
        .then(res => {
          if (res.code === 4001) { // 调用微信支付接口失败，例如：订单号重复
            this.$message.error(res.msg)
          } else { // 成功调用微信支付接口，拿到二维码并开始计时
            this.wechatCodeimg = res.data
            this.waitwechar(this)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 选择支付宝支付，并跳转网页
    zhiPay () {
      // 加载支付宝支付组件(这里不需要再加载了，所以witchPay还是0)
      this.witchPay = 0
      // 定义请求头
      let config = {
        headers: {
          'Authorization': 'Bearer' + this.$store.state.Token
        }
      }
      // 调用支付宝支付接口
      HttpServer.get('http://api.gdics.cn/api/alipay', config)
        .then(res => {
          console.log(res)
          this.zhiForm = res
          this.$nextTick(() => {
            document.getElementById('alipaysubmit').submit()
          })
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 循环检测微信支付状态
    waitwechar (that) {
      let config = {
        headers: {
          'Authorization': 'Bearer' + this.$store.state.Token
        }
      }
      clearInterval(that.timer)
      that.timer = setInterval(function () {
        HttpServer.get('http://api.gdics.cn/api/wepay_query', config)
          .then(res => {
            console.log(res)
            if (res.code === 200) { // 支付成功
              that.witchPay = 3
              clearInterval(that.timer)
              // that.$router.push('/joinProcess')
              // 把支付成功的状态码6传给父元素
              that.$emit('listenToChild', 6)
            } else if (res.code === 2001) { // 等待支付
            } else if (res.code === 4004) { // 支付失败
              that.witchPay = 4
              clearInterval(that.timer)
            }
          })
          .catch(err => {
            clearInterval(that.timer)
            console.log(err)
          })
      }, 3000)
    },

    // 返回选择支付方式
    backPay () {
      this.witchPay = 0
      clearInterval(this.timer)// 清除定时器
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)// 销毁组件时也清除一次
  }
}
</script>

<style scoped>
  .payBox{
    padding-top: 110px;
  }
  .payBox span{
    font-size: 18px;
    font-weight: 600;
  }
  .payBox p{
    margin-top: 50px;
    font-size: 12px;
  }
  .payNum{
    color: red;
  }
  .paywayimg{
    width: 70px;
    height: 70px;
    cursor: pointer;
    border: 2px #e7e7e7 solid;
  }
  .weBox{
    padding-top: 40px;
  }
  .weTitle{
    margin-bottom: 5px;
    color: #005cbf;
    font-size: 24px;
    font-weight: 600;
  }
  .weCode{
    width: 250px;
    height: 250px;
  }
  .zhiBox{
    padding-top: 40px;
  }
  .zhiTitle{
    margin-bottom: 5px;
    color: #005cbf;
    font-size: 24px;
    font-weight: 600;
  }
  .backPay{
    position: absolute;
    bottom: 10px;
    right: 30px;
    cursor: pointer;
    color: #005cbf;
    font-size: 14px;
  }
  .endBox{
    padding-top: 180px;
  }
  .payTitle{
    color: #1c7430;
    font-size: 18px;
    font-weight: 600;
  }

</style>



// WEBPACK FOOTER //
// src/components/joinprocess/processPay.vue